module.exports = __webpack_public_path__ + "img/cxyd-icon-1@2x.be226954.png";